import trackResponse from "@/utils/miscellaneous/track-response/index"
import Errors from "@/services/Errors";
import rollbarConfig from "@/config/rollbar";
import router from "../../router"
import codes from "./metadata"

export default {
  namespaced: true,
  state: {
    errorCode: null,
    errorReason: null,
    showToast: false,
    toastContent: {},
    errors: new Errors({}),
  },

  mutations: {
    SET_ERROR_CODE: (state, data) => {
      state.errorCode = data
    },

    SET_ERROR_REASON: (state, data) => {
      state.errorReason = data
    },

    SET_ERRORS: (state, data) => {
      state.errors = data
    },

    SET_SHOW_TOAST: (state, data) => {
      state.showToast = data
    },

    SET_TOAST_CONTENT: (state, data) => {
      state.toastContent = data
    },
  },

  actions: {
    handleErrors({
      state,
      commit,
      dispatch,
      rootState,
    }, {
      errors,
      showGlobalAlert,
      disableDefaultErrorHandlingAt = [],
      url = "",
      params,
      body,
      excludedLogFields,
      disableLoggingAt,
    }) {
      if (state.errorCode === errors.status) return
      commit("SET_ERROR_CODE", errors.status)

      if (disableDefaultErrorHandlingAt.includes(errors.status)) {
        return;
      }

      if (![451, 503, 401].includes(errors.status) && showGlobalAlert) {
        trackResponse({
          type: "error",
          msg: errors.message,
        })
      }

      if (codes[errors.status]?.rollbarTracking && !disableLoggingAt.includes(errors.status)) {
        const mutatedBody = { ...body };

        excludedLogFields.forEach((key) => {
          mutatedBody[key] = "******************";
        })

        rollbarConfig.critical(errors.message, {
          endpoint: url,
          status: errors.status,
          errorMessage: errors.message,
          user: {
            id: rootState.User.user?.id || null,
            email: rootState.User.user?.email || null,
            name: rootState.User.user?.name || null,
            role: rootState.User.user?.roleName || null,
          } || {},
          ...(params && { params }),
          ...(body && { body: mutatedBody }),
        });
      }

      if (errors.status === 451) {
        commit("SET_ERROR_REASON", errors.reason)
        commit("SET_ERRORS", errors)
      }

      if (errors.status === 401) {
        dispatch("Authentication/handleInvalidTokens", null, { root: true })
      }

      if (errors.status === 422 || errors.status === 406) {
        dispatch("setRequestValidationErrors", { errors })
      }

      const code = codes[errors.status]
      if (code?.redirectTo) {
        router.push({ name: code.redirectTo })
      }
    },

    setRequestValidationErrors({ commit }, { errors }) {
      const errorsObject = new Errors()

      Object.entries(errors.validations)
        .forEach(([key, val]) => {
          errorsObject.recordField({
            [key]: val[0],
          });
        });

      commit("SET_ERRORS", errorsObject)
    },

    resetErrorsState({ commit }) {
      commit("SET_ERRORS", new Errors({}))
      commit("SET_ERROR_CODE", null)
    },

    toggleShowToast({
      commit,
      state,
    }) {
      commit("SET_SHOW_TOAST", !state.showToast)
    },

    setToastContent({ commit }, data) {
      commit("SET_TOAST_CONTENT", data)
    },
  },
}
